import request from "@/common/request"
import { AutenticacaoRemota, AutenticacaoRemotaDTO, Page, StatusDaAutenticacaoRemota } from "@/models"
import { AxiosRequestConfig } from "axios"

const basePath = '/autenticacao-remota'

export const findAutenticacoesRemotas = async (params?: any, config?: AxiosRequestConfig): Promise<Page<AutenticacaoRemota>> =>
	request.get(`${basePath}`, {params, ...config})

export const atualizarStatusDaAutenticacaoRemota = async (autenticacaoId: string, status: StatusDaAutenticacaoRemota): Promise<AutenticacaoRemota> =>
	request.patch(`${basePath}/${autenticacaoId}?status=${status}`)

export const criarAutenticacaoRemota = async (autenticacaoRemota: AutenticacaoRemotaDTO): Promise<AutenticacaoRemota> =>
	request.post(`${basePath}`, autenticacaoRemota)

export const findById = async (autenticacaoRemotaId: string): Promise<AutenticacaoRemota> =>
	request.get(`${basePath}/${autenticacaoRemotaId}`)